import SotGa4MappingTool from "./SotGa4MappingTool";

export default SotGa4MappingTool;
